import _objectSpread from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.map.js";
import { mapActions } from 'vuex';
import utils from '@/utils';
import table from '@/mixins/crud-table.js';
export default {
  mixins: [table],
  components: {
    componentForm: function componentForm() {
      return import('./form');
    }
  },
  render: function render() {
    var _this = this;

    var h = arguments[0];
    var page = h("d2-container", {
      "attrs": {
        "spacious": true
      }
    }, [h("d2-search-panel", {
      "slot": "header",
      "model": {
        value: _this.search.panel.active,
        callback: function callback($$v) {
          _this.$set(_this.search.panel, "active", $$v);
        }
      }
    }, [h("d2-bar", {
      "slot": "title"
    }, [h("d2-bar-space"), this.p('query') ? h("d2-bar-cell", [this.vNodePaginationMini]) : h("d2-bar-cell", [this.vNodeSearchPanelAlertNoPermissionQuery]), h("d2-bar-space"), h("d2-bar-cell", [h("el-button-group", [this.p('query') ? this.vNodeButtonSearch : null, this.vNodeButtonTableColumnsFilterTrigger])]), this.p('add') ? h("d2-bar-cell", [this.vNodeButtonCreate]) : null]), this.p('query') ? this.vNodeSearchForm : null]), this.vNodeTable, h("d2-bar", {
      "slot": "footer"
    }, [h("d2-bar-cell", [this.vNodePaginationFull]), h("d2-bar-space")]), h("component-form", {
      "ref": "form",
      "on": {
        "success": this.research
      }
    }), this.vNodeTableColumnsFilter]);
    return page;
  },
  data: function data() {
    return {
      api: {
        index: 'SMS_RECORD_ALL',
        delete: 'SMS_RECORD_DELETE'
      },
      permission: {
        query: '',
        add: 'sms:record:add',
        edit: 'sms:record:edit',
        detail: '',
        remove: 'sms:record:remove'
      }
    };
  },
  computed: {
    // 配置项
    // 表格列
    // 建议的书写顺序 [prop] -> [label] -> [align] -> [minWidth][width] -> [fixed] -> [other] -> [render][formatter] -> [if][show]
    settingColumns: function settingColumns() {
      var h = this.$createElement;
      return [{
        prop: 'id',
        label: this.$t('id'),
        minWidth: '80px'
      }, {
        prop: 'market_id',
        label: this.$t('market_id'),
        minWidth: '100px'
      }, // { prop: 'device_uid', label: 'device_uid', width: '160px' },
      // { prop: 'device_number', label: 'device_number', width: '80px' },
      {
        prop: 'sms_record_key',
        label: this.$t('key'),
        minWidth: '180px'
      }, {
        prop: 'sms_reocrd_errorMsg',
        label: this.$t('errorMsg'),
        minWidth: '80px'
      }, {
        prop: 'user_mobile',
        label: this.$t('user_mobile'),
        minWidth: '100px'
      }, // { prop: 'sms_record_type', label: 'sms_record_type', width: '80px' },
      // { prop: 'sms_record_sType', label: 'sms_record_sType', width: '80px' },
      {
        prop: 'sms_record_status',
        label: this.$t('status'),
        minWidth: '80px',
        render: function render(_ref) {
          var row = _ref.row;
          return h("d2-dict", {
            "attrs": {
              "name": "sms_record_status",
              "value": row.sms_record_status
            }
          });
        }
      }, {
        prop: 'sms_record_content',
        label: this.$t('content'),
        minWidth: '200px'
      }, {
        prop: 'sms_cost_count',
        label: this.$t('cost_count'),
        minWidth: '100px'
      }, // { prop: 'sms_cost_count', label: 'sms_cost_count', width: '80px' },
      // { prop: 'updatetime', label: 'updatetime', width: '160px', formatter: row => utils.time.format1(row.updatetime, 'YYYY/M/D HH:mm:ss') },
      {
        prop: 'uptime',
        label: this.$t('uptime'),
        minWidth: '160px',
        formatter: function formatter(row) {
          return utils.time.format1(row.uptime, 'YYYY/M/D HH:mm:ss');
        }
      }, {
        prop: 'ctime',
        label: this.$t('ctime'),
        minWidth: '160px',
        formatter: function formatter(row) {
          return utils.time.format1(row.ctime, 'YYYY/M/D HH:mm:ss');
        }
      }].map(function (setting) {
        setting.sortable = 'custom';
        return setting;
      });
    },
    // 配置项
    // 表格操作列配置
    settingActionsConfig: function settingActionsConfig() {
      return function (_ref2) {
        var row = _ref2.row;
        return [// ...this.p('edit', [{ icon: 'el-icon-edit-outline', action: () => this.edit(row.id) }], []),
          // ...this.p('remove', [{ icon: 'el-icon-delete', type: 'danger', confirm: this.$t('confirm_delete_info'), action: () => this.delete(row.id) }], [])
        ];
      };
    },
    // 配置项
    // 表格搜索条件
    // 建议的书写顺序 [prop] -> [label] -> [default] -> [render] -> [if][show]
    settingSearch: function settingSearch() {
      var _this2 = this;

      var h = this.$createElement;
      return [{
        prop: 'market_id',
        label: this.$t('market_id'),
        default: parseInt(utils.cookies.get('market_id')),
        show: false,
        render: function render() {
          return h("el-input", {
            "style": "width:120px;",
            "model": {
              value: _this2.search.form.model.market_id,
              callback: function callback($$v) {
                _this2.$set(_this2.search.form.model, "market_id", $$v);
              }
            }
          });
        } // render: () => <d2-dict-select name="search_market_id" vModel={ this.search.form.model.market_id } style="width:140px;" custom clearable/>

      },
      /* {
        prop: 'app_id',
        label: this.$t('app_id'),
        default: '',
        render: () => <el-input vModel={ this.search.form.model.app_id } style="width:190px;" clearable/>
      }, */
      {
        prop: 'start_time',
        label: this.$t('start_time'),
        default: '',
        render: function render() {
          return h("el-date-picker", {
            "attrs": {
              "value-format": "yyyy-MM-dd",
              "type": "date",
              "placeholder": "start_time"
            },
            "style": "width:130px;",
            "model": {
              value: _this2.search.form.model.start_time,
              callback: function callback($$v) {
                _this2.$set(_this2.search.form.model, "start_time", $$v);
              }
            }
          });
        }
      }, {
        prop: 'end_time',
        label: this.$t('end_time'),
        default: '',
        render: function render() {
          return h("el-date-picker", {
            "attrs": {
              "value-format": "yyyy-MM-dd",
              "type": "date",
              "placeholder": "end_time"
            },
            "style": "width:130px;",
            "model": {
              value: _this2.search.form.model.end_time,
              callback: function callback($$v) {
                _this2.$set(_this2.search.form.model, "end_time", $$v);
              }
            }
          });
        }
      }];
    }
  },
  methods: _objectSpread({}, mapActions('d2admin/page', ['closeBy']))
};